import { render } from "./ArrowIcon.vue?vue&type=template&id=8673c97c&scoped=true"
const script = {}

import "./ArrowIcon.vue?vue&type=style&index=0&id=8673c97c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8673c97c"]])

export default __exports__